/**
 * 
 * @param {string} mensaje 
 * @param {string} tipo - 'success', 'danger', 'info' o 'warning' (default: 'info')
 */
export function mostrarToast(mensaje, tipo = 'info') {
    
    let toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3';
        document.body.appendChild(toastContainer);
    }
    
    
    const toastId = 'toast-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    
    const estilosClasificados = {
        success: { toast: 'border-0', body: 'bg-success text-white' },
        danger:  { toast: 'border-0', body: 'bg-danger text-white' },
        info:    { toast: 'border-0', body: 'bg-info text-white' },
        warning: { toast: 'border-0', body: 'bg-warning text-dark' } 
    };
    
    const estiloActual = estilosClasificados[tipo] || estilosClasificados.info;
    
   
    const toastHTML = `
        <div id="${toastId}" class="toast align-items-center ${estiloActual.toast}" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body w-100 rounded-2 ${estiloActual.body}">
                    ${mensaje}
                </div>
            </div>
        </div>
    `;
    
    toastContainer.insertAdjacentHTML('beforeend', toastHTML);
    const toastElemento = document.getElementById(toastId);
    
    
    if (typeof bootstrap !== 'undefined' && bootstrap.Toast) {
        const toastInstancia = new bootstrap.Toast(toastElemento, { 
            delay: 3000,
            autohide: true 
        });
        
        
        toastElemento.addEventListener('hidden.bs.toast', function() {
            this.remove();
        });
        
        toastInstancia.show();
    } else {
        console.error('Bootstrap no está cargado en el entorno global.');
        
        toastElemento.style.display = 'flex';
        setTimeout(() => { toastElemento.remove(); }, 3000);
    }
}

/**
 * Transforma una fecha en formato ISO-8601 a un formato legible DD/MM/AAAA
 * @param {string} fechaStr - La fecha cruda que viene de PostgreSQL
 * @returns {string} Fecha formateada o '-' si viene vacía
 */
export function formatearFecha(fechaStr) {
    if (!fechaStr || fechaStr === 'null' || fechaStr === '-') return '-';
    
   
    const partes = fechaStr.substring(0, 10).split('-');
    if (partes.length !== 3) return fechaStr;
    
    const [anio, mes, dia] = partes;
    return `${dia}/${mes}/${anio}`; 
}

/**
 * Genera dinámicamente la URL base para las APIs del Backend.
 * @param {string} puertoBackend 
 * @returns {string} 
 */
export function obtenerUrlBackend(puertoBackend = '8083') {
    
    const dominioActual = window.location.hostname;
    const protocoloActual = window.location.protocol; 
    
    if (dominioActual === 'localhost' || dominioActual === '127.0.0.1') {
        return `http://localhost:${puertoBackend}`;
    }

    return `${protocoloActual}//${dominioActual}:${puertoBackend}`;
  
}